import { Module } from "@nestjs/common";
import { EmployeeEntity } from "./employee.entity";
import { EmployeeController } from "./employee.controller";
import { EmployeeService } from "./employee.services";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { TypeOrmModule } from "@nestjs/typeorm";
import { EmployeeRepo } from "./employee.repo";



@Module({
    imports: [
        TypeOrmModule.forFeature([EmployeeEntity]),
    ],
    controllers: [EmployeeController],
    providers: [EmployeeService, ApplicationExceptionHandler,EmployeeRepo]
})
export class EmployeeModule {

}